<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'advance-search-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Đưa văn bản đi về Chờ ban hành</h3>
      <el-form  ref="form" :model="advanceSearchForm" label-position="right" :rules="validationRules" >
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Số ký hiệu" class="formItem" prop="docCode"
                          >
              <el-input
                v-model="advanceSearchForm.docCode"
                v-focus.native
                class=""
                placeholder="-"
                size="medium"
                @change="onChangeDocCode"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Ngày văn bản" class="formItem" prop="docDate"
                          >
              <el-date-picker
                class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.docDate"
                type="date"
                :prefix-icon="' '"
                placeholder="dd/mm/yyyy"
                format="dd/MM/yyyy"
                @change="onChangeDocDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-table
          v-if="vbOutgoingDocs && vbOutgoingDocs.length > 0"
          ref="multipleTable"
          :data="vbOutgoingDocs"
          size="mini"
          stripe
          style="width: 100%"
          max-height="300"
          @selection-change="docSelectionChange"
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column
            label="Trích yếu"
            show-overflow-tooltip
          >
            <template slot-scope="scope"
                      @click="itemClicked(scope.row)">
              <span
              >{{ scope.row.quote }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            property="docDate"
            label="Ngày văn bản"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                @click="itemClicked(scope.row)">{{
                  scope.row.docDate | dateFormatter
                }}</span>
            </template>
          </el-table-column>
          <el-table-column property="docCode" label="Số ký hiệu" width="125">
            <template slot-scope="scope"
                      @click="itemClicked(scope.row)">
              <div class="flex-row flex__left" >
                <p>{{ scope.row.docCode }}</p>
              </div>
            </template>
          </el-table-column>

        </el-table>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="executeThayDoi">
          <i class="fas fa-search font-size__small"></i>
          Xác nhận
        </el-button>

        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Reset
        </el-button>

      </div>
    </template>
  </custom-dialog>
</template>

<script>
import utils from "../../../services/utils";
import VbdiSortSelect from "../../common/vbdi-sort-select";
import outgoingDocService from "../../../services/outgoingDocService";
import Vue from "vue";
import {EventBus} from "../../../event-bus";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  filters: {dateFormatter},
  name: "vb-di-thay-doi-status-dialog",
  props: ["isOpen", "form", "isEnableSearchTdhvpDoc"],
  components: {
    VbdiSortSelect,
    customDialog: () => import("../../common/custom-dialog.vue"),
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },
  },

  data() {
    return {
      vbOutgoingDocs: [],
      sortList: [],
      publisherDepartments: [],
      listInsideReceiver: [],
      validationRules: {},
      isLoading: false,
      receiveDepartments: [],
      docTypes: [],
      departments: [],
      priorities: [],
      selectType: null,
      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
      docDateRange: null,
      advanceSearchForm: {
        docCode: null,
        docDate: null,
      },
      selectedProcess: [],

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
    };
  },

  created() {
    this.initValidationRules();
  },

  methods: {
    selectedSort(event){
      this.sortList=event.sortList;
    },
    onChangeDocCode(docCode) {
      this.onChangeVb(docCode, this.advanceSearchForm.docDate);
    },
    onChangeDocDate(docDate) {
      this.onChangeVb(this.advanceSearchForm.docCode, docDate);
    },
    onChangeVb(docCode, docDate){
      return outgoingDocService.timKiemVanBanDi(docCode, docDate ? docDate.getTime() : null).then(
        (response) => {
          this.vbOutgoingDocs = response.data;
          if(this.vbOutgoingDocs.length < 1) {
            this.$message.error("Không tìm thấy văn bản");
          }
        }
      )
    },
    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve();
          } else {
            this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          }
        });
      })
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      Vue.set(this.validationRules, "docCode", [defaultRequiredConstrains]);

    },
    executeThayDoi() {
      return this.validateForm().then(() => {
        if (this.selectedProcess.length === 0) {
          this.notify(
            "Lỗi",
            "Chưa chọn văn bản để thay đổi !",
            "error",
            2000
          );
          return;
        }
        else if (this.selectedProcess.length > 1)
        {
          this.notify(
            "Lỗi",
            "Không được chọn quá một văn bản để thay đổi !",
            "error",
            2000
          );
          return;
        }
        return outgoingDocService.thayDoiTrangThaiBanHanhVeDuThao(this.selectedProcess[0].id).then((response) => {
          if(response.data) {
            this.$message.success("Đưa văn bản về trạng thái Chờ ban hành thành công");
            EventBus.$emit(this.parentRoute, {});
            this.reset()
            this.$emit("closeDialog");
          }
          else {
            this.$message.error("Không xử lý được do không tìm thấy văn bản hoặc có nhiều văn bản trùng số ký hiệu")
            this.$emit("closeDialog");
          }
        })
      })
    },
    docSelectionChange(val) {
      this.selectedProcess = val;
    },
    itemClicked(item) {
      this.$refs.multipleTable.toggleRowSelection(item);
    },
    reset() {
      this.advanceSearchForm.docCode = null;
      this.advanceSearchForm.docDate = null;
      this.vbOutgoingDocs = [];
    }
  }
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}

.filter {
  background-color: #d5d7dd;
  border-radius: 4px;
  padding: 13px 10px;
  margin-bottom: 10px;
}

.filter .item {
  color: #007aff;
  font-size: 15px;
  font-weight: 500;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/quanLyThayDoiStatusVbDi/vb-di-thay-doi-status-dialog.vue